'use client';

import {
    Alert,
    Align,
    Button,
    ButtonVariant,
    Card,
    CardContent,
    Column,
    Columns,
    FlexBox,
    FlexItem,
    Image,
    Justify,
    StatusState,
    Sticker,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { RepeaterProduct } from '@app-types/product';

import { InlinePrice } from '@components/inline-price';

import { MEDIA_BASE_URL } from '@helpers/config';

import { useHome } from '@landing/hooks';

interface BboxOtisOptionProps {
    onClick: () => void;
    onAddOtisRepeater: () => void;
    shouldShowAlert: boolean;
    repeater: RepeaterProduct;
}

export default function BboxOtisOption({
    onClick,
    onAddOtisRepeater,
    shouldShowAlert,
    repeater,
}: Readonly<BboxOtisOptionProps>) {
    const { selectedFaiOption } = useHome();

    return (
        <>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                En option&nbsp;: le WiFi à tous les étages
            </Text>
            <Alert
                status={StatusState.WARNING}
                display={shouldShowAlert}
                title="Ajoutez d'abord l'offre Pure Fibre"
                description="L'option répéteur WiFi est seulement compatible avec une offre Pure Fibre. Ajoutez-en une pour continuer !"
            />
            <Card horizontal id='repeater-configurator' className='is-shadowless no-wrap'>
                <FlexBox
                    className='has-background-info-fade is-marginless'
                    mobile
                    justify={Justify.CENTER}
                    align={Align.CENTER}
                >
                    <FlexItem narrow>
                        <Image
                            alt=''
                            width={80}
                            src={repeater.imgRepeater?.public_url || `${MEDIA_BASE_URL}/Repeteur.webp`}
                        />
                    </FlexItem>
                </FlexBox>
                <CardContent>
                    <Columns gap={2} verticalAlign={Align.CENTER}>
                        <Column>
                            {repeater.promoLabel && (
                                <Sticker variant={TrilogyColor.ACCENT} small label={repeater.promoLabel} />
                            )}
                            <Text level={TextLevels.ONE} marginless>
                                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} markup={TextMarkup.SPAN}>
                                    {repeater.name ?? 'Répéteur WiFi'}
                                </Text>
                                <Text markup={TextMarkup.SPAN} level={TextLevels.TWO}>
                                    &nbsp;+
                                    <InlinePrice
                                        typo={[]}
                                        level={TextLevels.TWO}
                                        amount={repeater.prices.final}
                                        period='mois'
                                    />
                                </Text>
                            </Text>
                            <Text level={TextLevels.TWO} marginless>
                                {repeater.shortDescription ?? 'Idéal pour les logements de plus de 80 m²'}
                            </Text>
                            <button onClick={onClick} className='button-clear link text is-level-2'>
                                {repeater.textLink ?? 'Ai-je besoin d‘un répéteur\u00A0?'}
                            </button>
                        </Column>
                        <Column narrow>
                            <Button
                                variant={selectedFaiOption ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
                                onClick={onAddOtisRepeater}
                            >
                                {selectedFaiOption ? 'Retirer du panier' : 'Ajouter au panier'}
                            </Button>
                        </Column>
                    </Columns>
                </CardContent>
            </Card>
        </>
    );
}
